export const ACTIVE_COLOR = "#F79F1F"
export const INACTIVE_COLOR = "#A2A2A2"
export const STAR_COUNT = 5
